export default "/images/framework/Badge_09.dd6df6ba.svg?dd6df6ba";